import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import useSEO from "@/hooks/useSEO";
import { Loader2 } from "lucide-react";

export default function MagicLogin() {
  useSEO({ title: "Signing you in — ErrandDay", noindex: true, canonicalPath: "/magic-login" });
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refreshMe } = useAuth();
  const [err, setErr] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setErr("Missing token in URL"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/magic-consume", { token });
        await refreshMe();
        if (data.user.role === "agent") navigate("/agent", { replace: true });
        else if (data.user.role === "admin") navigate("/admin", { replace: true });
        else navigate("/dashboard", { replace: true });
      } catch (e) { setErr(formatApiError(e)); }
    })();
  }, [params, navigate, refreshMe]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 text-center">
      {err ? (
        <div className="eb-card p-8 max-w-md">
          <h2 className="text-2xl">This link can&apos;t be used</h2>
          <p className="mt-3 text-[var(--eb-text-dim)]">{err}</p>
          <Link to="/login" className="eb-btn eb-btn-primary mt-6 inline-flex">Back to sign in</Link>
        </div>
      ) : (
        <div className="text-[var(--eb-text-dim)] flex flex-col items-center gap-3">
          <Loader2 className="w-7 h-7 animate-spin text-[var(--eb-primary)]" />
          <div>Signing you in…</div>
        </div>
      )}
    </div>
  );
}
